import { arrayOf } from 'utils';
import { hasAtLeastOneTruthyValue } from 'utils/obj_utils_new';
import { DateTime } from 'luxon';
import { OnDemandRecurrenceType, RecurrenceScheduleType, RecurrenceType } from './recurrence_enums';
import { Recurrence } from './recurrence_interfaces';


// TODO: Cover all cases
export const nextAutomationDatetimes =
(
	recurrence: Recurrence,
	count: number = 8,
	relative_datetime: DateTime = DateTime.local(),
)
: DateTime[] =>
{
	let schedule = recurrence.recurrence_schedule;
	
	
	// TODO: When viewing, ensure this is a Datetime
	// When does this template take effect? Sometime in the future?
	let effective = (recurrence.effective_datetime as DateTime);
	
	// Take the relative or effective datetime, whichever is further in the future
	// This datetime will be the basis of comparisons
	let basis = (effective < relative_datetime)
		? relative_datetime
		: effective
	
	
	// if(recurrence.recurrence_type === RecurrenceType.ONCE)
	// {
	// 	return [basis];
	// }
	
	
	
	
	
	
	
	
	if(schedule === RecurrenceScheduleType.ON_DEMAND)
	{
		return [];
	}
	else
	{
		if(schedule === RecurrenceScheduleType.MONTHLY)
		{
			if(recurrence.monthly.day_numbers)
			{
				// let is_basis_past_target_time = basis.hour > 
				
				let day_nums = recurrence.monthly.day_numbers;
				
				
				// Finds the first day number that's bigger than/equal to the current day
				// This will be the first day we project
				let index = day_nums.findIndex(day_num => {
						return (
							(day_num > basis.day)
							||
								((day_num === basis.day)
									&& (basis.hour <= effective.hour)
									&& (basis.minute <= effective.minute)
									&& (basis.second <= effective.second)
								)
						)
				});
				
				// If no days are greater, the first projected date will use the earliest day number
				index = (index === -1)
					? 0
					: index;
				
				
				let months_offset = 0;
				
				
				let projected_dts = arrayOf(count, (i: number) =>
				{
					// let index_in_ordered = index + i % ordered_nums.length;
					let looping_index = (index + i) % day_nums.length;
					
					if(looping_index === 0)
					{
						months_offset++;
					}
					
					let new_dt = basis.plus({
						months: months_offset,//Math.floor(i / day_nums.length),
					})
					
					let new_day_num = day_nums[looping_index];
					let last_day_of_month = new_dt.endOf('month').day;
					
					if(new_day_num > last_day_of_month)
					{
						new_day_num = last_day_of_month;
					}
					
					return new_dt.set({
						day: new_day_num,
					})
				})
				
				return projected_dts
			}
			else
			{
				return null;
			}
			
			
			
			/*
			
			
			
			// Ex: It's the 10th, and something should happen on the 15th => do it in 5 days
			if(dt.day < recurrence.monthly.day_number)
			{
				return dt.plus({
					days: recurrence.monthly.day_number - dt.day,
				})
			}
			// Ex: It's the 15th, and something should happen on the 15th => do it today if the time is in the future
			if(
				(dt.day === recurrence.monthly.day_number)
				&&
				(
					(basis.hour < recurrence.time_of_day.hour)
					||
					(
						(basis.hour === recurrence.time_of_day.hour)
						&&
						(basis.minute <= recurrence.time_of_day.minute)
					)
				)
			)
			{
				return basis.set({
					...recurrence.time_of_day,
				})
			}
			// Ex: It's the 20th, and something should happen on the 15th => do it in 1 month minus 5 days
			else
			{
				return dt.plus({
					months: 1,
					days: recurrence.monthly.day_number - dt.day,
				})
			}
			
			*/
			
			
			
			
			// return [
			// 	nextAutomationDatetime(recurrence, relative_datetime),
			// ]
		}
	}
	
	
	
	
	
	
	
	
	
	// if(
	// 	(recurrence.recurrence_type === RecurrenceType.ONCE)
	// )
	// {
	// 	return [
	// 		nextAutomationDatetime(recurrence, relative_datetime),
	// 	]
	// }
	
	if(
		(recurrence.recurrence_type === OnDemandRecurrenceType.TRIGGER)
	)
	{
		return [
		]
	}
	
	
	let first_dt = nextAutomationDatetime(recurrence, relative_datetime);
	
	
	if(!first_dt)
	{
		return [];
	}
	
	
	// console.log(first_dt);
	
	
	
	// if(recurrence.recurrence_type === RecurrenceType.INTERVAL)
	// {
	// 	return arrayOf(
	// 		count,
	// 		(i: number, results: DateTime[]) =>
	// 		{
	// 			if(i > 0)
	// 			{
	// 				return nextAutomationDatetime(recurrence, results[i - 1].plus({milliseconds: 1}));
	// 			}
	// 			else
	// 			{
	// 				return first_dt;
	// 			}
	// 		}
	// 	)
	// }
	
	
	// TODO: If effective datetime is in the past, the current time kind of replaces it as the basis
	
	let results = arrayOf(
		count,
		(i: number, results: DateTime[]) =>
		{
			if(i > 0)
			{
				return nextAutomationDatetime(
					recurrence,
					results[i - 1].plus({milliseconds: 1}),
					results[i - 1],
				);
			}
			else
			{
				return first_dt;
			}
		}
	)
	
	if(recurrence.recurrence_type === RecurrenceType.INTERVAL)
	{
		return results //.map(x => x.minus(recurrence.interval));
	}
	else
	{
		return results;
	}
	
}



export const nextAutomationDatetime =
(
	recurrence: Recurrence,
	relative_datetime: DateTime = DateTime.local(),
	prev_datetime?: DateTime,
)
: DateTime =>
{
	// When does this template take effect? Sometime in the future?
	let effective = (recurrence.effective_datetime as DateTime);
	
	
	if(recurrence.recurrence_type === OnDemandRecurrenceType.ONCE)
	{
		return effective;
	}
	
	
	// Take the relative or effective datetime, whichever is further in the future
	// This datetime will be the basis of comparisons
	let basis = (effective < relative_datetime)
		? relative_datetime
		: effective
	
	// let now = DateTime.utc();
	
	
	
	// TODO: Add config option to include effective datetime first rather than adding interval
	if(recurrence.recurrence_type === RecurrenceType.INTERVAL)
	{
		// Check if the interval is empty of unit-amount pairs
		if(!hasAtLeastOneTruthyValue(recurrence.interval))
		{
			return null;
		}
		
		// If effective datetime is in the past...
		
		
		// If the caller provides a previous datetime, this can be used for projecting into the future
		// TODO: rename?
		if(prev_datetime)
		{
			return prev_datetime.plus(recurrence.interval)
		}
		
		
		if(recurrence.skip_first)
		{
			return basis.plus(recurrence.interval)
		}
		else
		{
			return basis;
		}
		
		// if(basis <= now)
		// {
		// 	if(recurrence.skip_first)
		// 	{
		// 		return basis.plus(recurrence.interval)
		// 	}
		// 	else
		// 	{
		// 		return basis;
		// 	}
		// }
		
		
		
		
		
		// return (effective < relative_datetime)
		// 	? relative_datetime.plus(recurrence.interval)
		// 	: effective.plus(recurrence.interval)
		
		// return effective.plus(recurrence.interval);
		
		
		// if(basis < relative_datetime)
		// {
		// 	let now = DateTime.utc();
			
		// 	if(now > basis)
		// 	{
		// 		return now;
		// 	}
		// 	else
		// 	{
		// 		return basis;
		// 	}
		// }
		// else
		// {
		// 	return effective.plus(recurrence.interval);
		// }
		
	}
	
	
	// TODO: Rename
	let dt = basis.set(recurrence.time_of_day);
	
	
	if(recurrence.recurrence_type === RecurrenceType.SCHEDULE)
	{
		// Ex: It's noon, and something happens at 9 AM every day => tomorrow at 9 AM
		if(recurrence.recurrence_schedule === RecurrenceScheduleType.DAILY)
		{
			if(basis < dt)
			{
				return dt;
			}
			else
			{
				return dt.plus({ days: 1 })
			}
		}
		
		if(recurrence.recurrence_schedule === RecurrenceScheduleType.WEEKLY)
		{
			let weekdays = recurrence.weekly.weekday_numbers.filter(Boolean);
			
			if(weekdays.length === 0)
			{
				return null;
			}
			
			// Ex: If today is Wednesday, [2, 4] would result in 1, since Thursday is the in the future
			let first_weekday_after = weekdays.find(x =>
				(x > basis.weekday)
				||
				(
					(x === basis.weekday)
					&&
					(
						(basis.hour < recurrence.time_of_day.hour)
						||
						(
							(basis.hour === recurrence.time_of_day.hour)
							&&
							(basis.minute < recurrence.time_of_day.minute)
						)
					)
				)
			);
			
			// Ex: If today is Friday, [2, 4] would result in -1, since neither Tuesday nor Thursday are after
			if(first_weekday_after === undefined)
			{
				return (
					dt.plus({
						days: weekdays[0] + 7 - dt.weekday,
					})
				)
			}
			else
			{
				return dt.plus({
					days: first_weekday_after - dt.weekday,
				})
			}
		}
		
		if(recurrence.recurrence_schedule === RecurrenceScheduleType.MONTHLY)
		{
			// Ex: [4, 26], 15
			if(recurrence.monthly.day_numbers)
			{
				// let is_now_past_target_time = dt.
				
				// Finds the first day number that's bigger than/equal to the current day
				// let index = recurrence.monthly.day_numbers.findIndex(x => x >= dt.day);
			}
			else
			{
				return null;
			}
			
			
			// Ex: It's the 10th, and something should happen on the 15th => do it in 5 days
			if(dt.day < recurrence.monthly.day_number)
			{
				return dt.plus({
					days: recurrence.monthly.day_number - dt.day,
				})
			}
			// Ex: It's the 15th, and something should happen on the 15th => do it today if the time is in the future
			if(
				(dt.day === recurrence.monthly.day_number)
				&&
				(
					(basis.hour < recurrence.time_of_day.hour)
					||
					(
						(basis.hour === recurrence.time_of_day.hour)
						&&
						(basis.minute <= recurrence.time_of_day.minute)
					)
				)
			)
			{
				return basis.set({
					...recurrence.time_of_day,
				})
			}
			// Ex: It's the 20th, and something should happen on the 15th => do it in 1 month minus 5 days
			else
			{
				return dt.plus({
					months: 1,
					days: recurrence.monthly.day_number - dt.day,
				})
			}
		}
		
		// Ex: It's August 1st, with something happening every June 15th
		//     We're already past that date this year, so result is June 15 next year
		if(recurrence.recurrence_schedule === RecurrenceScheduleType.YEARLY)
		{
			let candidate = dt.set({
				month: recurrence.yearly.yearly_date.month,
				day: recurrence.yearly.yearly_date.day,
			})
			
			if(candidate > dt)
			{
				return candidate;
			}
			else
			{
				return (candidate.plus({
					years: 1,
				}))
			}
		}
		
		
		return null;
	}
}


